let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1PFZq")).then(() => parcelRequire('31yzi'));